module.exports = __webpack_public_path__ + "static/img/1a (2).939fdf8b.png";